<template>
  <li class="tree__list__item"
      :class="[node.favorite ? 'filter-favorite' : '',
              node.hasFavorite ? 'children-favorite' : '',
              node.isFavorite ? 'current-favorite' : '']">
    <span class="tree__list__item--label" :style="{cursor: cursor}" :title="node.Name" @contextmenu="showTreeMenu($event, node)" @dblclick="toggle(node)"
          :class="[
          {'active': activeNode ===   node.Id},
          'level-' + node.level
          ]">
      <span class="tree__list__item--lines" @click="toggle(node)"
            :class="[
            node.HasSubfolders ? 'has-children' : 'has-no-children',
            isOpen ? 'open' : '',
            'level-' + node.level
            ]">
            <span class="tree__list__item--lines__icon" v-show="node.HasSubfolders">
              <p4a-icon :icon="'treeview-chevron'" />
            </span>
      </span>
      <span class="tree__list__item--icon" @click="selectInTheBackend" @click.prevent="activateNode(node.Id)"
            :class="[
            'level-' + node.level, node.root ? 'root' : '',
            node.IsTemplate ? 'template' : '',
            (node.Id === node.ProjectRootFolderId) ? 'linkedToproject' : '',
            node.Editable ? 'is-editable' : '',
            node.IsProjectFolder ? 'project' : '',
            node.IsProjectFolder && node.new ? 'new-project' : '',
            isTrash(node.Name) ? 'trash' : ''
            ]">
      </span>
      <span class="tree__list__item--section" @click="selectInTheBackend"
            @click.prevent="activateNode(node.Id)">
        {{ node.Name }}
      </span>
      <div class="tree__list--icons">
        <div class="icon map-favorite" v-if="node.IsFavorite"></div>
        <div class="icon map-confidential" v-if="node.IsConfidentialFolder"></div>
        <div class="icon map-writable" v-if="node.isWritable"></div>
      </div>
    </span>
    <transition name="slide">
      <div v-show="isOpen">
        <ol v-show="node.children && node.children.length"
            :class="node.children && node.children.length ? 'tree-has-children' : ''">
          <div>
          <node :activeNode="activeNode"
                :documentGrid="documentGrid"
                v-show="isOpen"
                v-for="child in node.children"
                :node="child"
                :key="child.node"
                @getPath="emitPath">
          </node>
          </div>
        </ol>
      </div>
    </transition>
  </li>
</template>

<script>
import * as treeviewApi from 'api/treeviewOldApi.js'
import mixins from 'mixins'
import _ from 'lodash'
import treeWindowEventHandler from 'api/treeWindowEventHandler.js'

export default {
  name: 'Node',
  mixins: [mixins],
  props: {
    activeNode: Number,
    node: Object,
    documentGrid: Boolean
  },
  data () {
    return {
      isOpen: false
    }
  },
  watch: {
    folderLoadFinishedEvent () {
      this.setCanClickNode(true)
    }
  },
  computed: {
    folderLoadFinishedEvent () {
      return treeWindowEventHandler.folderLoadFinished
    },
    canClickNode () {
      const load = this.$store.getters.folderLoadFinished
      return !this.documentGrid || load
    },
    cursor () {
      return this.canClickNode ? 'pointer' : 'not-allowed'
    }
  },
  mounted () {
    // set a location to prevent a javascript error
    const location = {
      href: window.location.href
    }
    window.parent.tree.location = location
    // Reopen the latest selected path
    const Ids = this.$store.getters.selectedNodePath
    if (Ids.length < 1) {
      Ids.push(-1)
    }
    Ids.forEach(element => {
      if (this.node.Id === element) {
        this.toggle(this.node)
      }
    })
    if (this.node.Id === this.activeNode) {
      const IsProjectFolder = this.node.IsProjectFolder
      this.setSelectedFolder(this.node)
      this.updateTheRightView(IsProjectFolder)
    }
  },
  methods: {
    isTrash (name) {
      let result = false
      const checkArray = ['Prullenbak', 'Corbeille', 'Recycle Bin', 'Papierkorb']
      checkArray.forEach(trashName => {
        if (name === trashName) result = true
      })
      return result
    },
    emitPath (event) {
      let result = [ this.node.Id ]
      if (event && event.nodePath) {
        result = result.concat(event.nodePath)
      }
      this.$emit('getPath', { nodePath: result })
    },
    fetchSelectedFolder (Id) {
      // Set selected folder in the backend then save the hash response as a cookie
      return window.fetch('/Events/Folder/FolderEvents.aspx?action=treeClick&folderId=' + Id, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(response => {
        return response.text()
      }).then(result => {
        if (result.indexOf('|') === 1) {
          result = result.slice(2)
          document.cookie = 'ds_h=' + result
          window.parent.getTop().createCookie('ds_h', result)
        }
      })
    },
    setSelectedFolder (node) {
      // Set slected folder in window for import documents
      let treeSelected = {
        SelectedNode: {
          ID: node.Id,
          Value: node.IsProjectFolder ? 'project' : 'folder'
        }
      }
      window.parent.tree.TreeView1 = treeSelected
    },
    showTreeMenu (e, node) {
      // Make the selected folder active by the right click
      this.activateNode(node.Id)
      // Set selected folder on the backend if not already did
      this.selectInTheBackend(node.Id)

      if (window.parent && window.parent.ContextMenuTree) {
        this.setSelectedFolder(node)
        // Show tree-menu in the right place
        if (node.Id === -1) {
          // This menu specifically for Root folder
          window.parent.ContextMenuTreeRoot.ShowContextMenu(e.x, e.y + 100, node.Id)
        } else if (node.Id === 1) {
          // This menu specifically for Recycle bin
          window.parent.ContextMenuTreeRecycleBin.ShowContextMenu(e.x, e.y + 100, node.Id)
        } else {
          // For the rest
          window.parent.ContextMenuTree.ShowContextMenu(e.x, e.y + 100, node.Id)
        }
      }
      e.preventDefault()
    },
    selectInTheBackend (event) {
      if (this.canClickNode) {
        this.setSelectedFolder(this.node)
        // Share path with parent
        this.emitPath(event)
        this.debounceSelectInBackend(this)
      }
    },
    debounceSelectInBackend: _.debounce((self) => {
      // Set selected folder on the backend if not already did
      const Id = self.$store.getters.selectedFolderId
      if (Id && Id === self.node.Id) {

      } else {
        self.fetchSelectedFolder(self.node.Id).then(done => {
          const IsProjectFolder = self.node.IsProjectFolder
          self.updateTheRightView(IsProjectFolder)
        })
        self.lockClickNode()
      }
      // Save selected folder Id
      self.saveSelectedFolderId(self.node.Id)
    }, 500),
    updateTheRightView (IsProjectFolder) {
      let reloadVueGrid = this.$store.getters.getUpdateRightView
      // Update the right view
      if (!IsProjectFolder) {
        this.$store.commit('setUpdateRightView', false)
        let frame = this.documentGrid === true ? 'updateVueDocumentView' : 'updateDocumentView'
        if (frame === 'updateVueDocumentView') {
          localStorage.setItem('GridVueloaded', true)
        } else {
          localStorage.setItem('GridVueloaded', false)
        }
        this.reloadIframe(frame, this.node.Id, reloadVueGrid)
        if (frame === 'updateVueDocumentView') {
          this.reloadIframe('expandVersionFrameFromProject')
        }
        this.reloadIframe('updatePropertiesViewForDocument')
      }
      if (IsProjectFolder) {
        this.$store.commit('setUpdateRightView', true)
        this.reloadIframe('updateProjectView')
        this.reloadIframe('updatePropertiesViewForProject')
      }
    },
    saveSelectedFolderId (id) {
      this.$store.commit('setSelectedFolderId', {id})
    },
    toggle (node) {
      this.setSelectedFolder(node)
      if (this.node.children) return (this.isOpen = !this.isOpen)
      this.$store.commit('setChildrenParentId', node.Id)
      // If the folder is the root don't get the folders again
      // To avoid doplicate api's calls
      if (node.Id === -1) {
        return () => {
          if (this.node.HasSubfolders) {
            this.isOpen = !this.isOpen
          }
        }
      }
      return treeviewApi.loadChildrenFolders(node.Id).then(folders => {
        node.children = folders
        if (this.node.HasSubfolders) {
          this.isOpen = !this.isOpen
        }
      })
    },
    activateNode (node) {
      if (this.canClickNode) { this.$eventBus.$emit('updateNodes', node) }
    },
    setCanClickNode (value) {
      this.$store.commit('setFolderLoadFinished', value)
    },
    lockClickNode () {
      let self = this
      self.setCanClickNode(false)
      // release the cursor if no events have returned to unlock
      setTimeout(() => {
        self.setCanClickNode(true)
      }, 2000)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/treeViewOldApi/treeNode.vue